import React from 'react';
import { useTranslation } from 'react-i18next';

import { TGatewayHealthChipProps } from '@/console/features/gateways/components/gateway-health-chip/gateway-health-chip.types';
import { useGatewayHealth } from '@/console/features/gateways/hooks/use-gateway-health/use-gateway-health';
import { GatewayIcon } from '@/shared/assets/icons/gateway-icon';
import { Chip } from '@/shared/components/ui/chip/chip';
import { ChipStatus } from '@/shared/components/ui/chip/chip.types';
import { GatewayStateEnum } from '@/shared/types/types.generated';

export const GatewayHealthChip: React.FC<TGatewayHealthChipProps> = ({
  gatewayId,
  gatewayName,
  descriptiveTooltip,
}) => {
  const { t } = useTranslation();
  const { state } = useGatewayHealth(gatewayId);

  const getChipColor = (): ChipStatus => {
    switch (state) {
      case GatewayStateEnum.Online:
        return 'green';
      case GatewayStateEnum.Offline:
        return 'red';
      default:
        return 'grey';
    }
  };

  const getTooltip = () => {
    const prefix = gatewayName ? `${gatewayName}: ` : '';
    const gatewayHealthState = t(
      `gateways:gateway_state.${state ? state.toLowerCase() : 'offline'}`,
    );

    if (descriptiveTooltip) {
      return `${prefix}${t('gateways:gateway_health')}: ${gatewayHealthState}`;
    }

    return `${prefix}${gatewayHealthState}`;
  };

  return (
    <Chip
      status={getChipColor()}
      label={<GatewayIcon />}
      tooltip={getTooltip()}
    />
  );
};
